/**
 * 共有操作タイプ
 */
export var ShareActionTypes;

(function (ShareActionTypes) {
  /**
   * 操作不可
   */
  ShareActionTypes[ShareActionTypes["None"] = 0] = "None";
  /**
   * 許可
   */

  ShareActionTypes[ShareActionTypes["Allow"] = 1] = "Allow";
  /**
   * 拒否
   */

  ShareActionTypes[ShareActionTypes["Deny"] = 2] = "Deny";
})(ShareActionTypes || (ShareActionTypes = {}));